import { Box, InfoDot, Text } from '@factorialco/deprecated-design-system'
import Decimal from 'decimal.js'

import i18n from 'modules/core/lib/i18n'

const NumericText: React.FC<{ leftValue: number; rightValue?: string; isPercentage?: boolean }> = ({
  rightValue,
  leftValue,
  isPercentage,
}) => {
  const roundedLeftValue = new Decimal(leftValue).toDecimalPlaces(isPercentage ? 0 : 2).toNumber()

  return (
    <Box flexDirection="row" alignItems="baseline">
      <Text size="700" weight="bold" color="grey1000">
        {i18n.formatNumber(roundedLeftValue)}
      </Text>
      {(isPercentage || rightValue) && (
        <Text size="500" weight="medium" color="grey1000">
          {isPercentage ? '%' : rightValue}
        </Text>
      )}
    </Box>
  )
}

export const AverageScore: React.FC<{ score: number; maxScore: number }> = ({
  score,
  maxScore,
}) => {
  return (
    <Box>
      <Text.Normal weight="medium" color="grey1000">
        {i18n.t('performance_process.insights.charts.average_score')}
      </Text.Normal>
      <NumericText leftValue={score} rightValue={`/${maxScore}`} />
    </Box>
  )
}

export const TopPerformers: React.FC<{ score: number }> = ({ score }) => {
  return (
    <Box>
      <Text.Normal weight="medium" color="grey1000">
        {i18n.t('performance_process.insights.charts.top_performers')}
      </Text.Normal>
      <Box flexDirection="row" alignItems="center" gap="s8">
        <InfoDot size="medium" color={'viridian1000'} />
        <NumericText leftValue={score} isPercentage />
      </Box>
    </Box>
  )
}

export const LowPerformers: React.FC<{ score: number }> = ({ score }) => {
  return (
    <Box>
      <Text.Normal weight="medium" color="grey1000">
        {i18n.t('performance_process.insights.charts.low_performers')}
      </Text.Normal>
      <Box flexDirection="row" alignItems="center" gap="s8">
        <InfoDot size="medium" color={'radicalRed1000'} />
        <NumericText leftValue={score} isPercentage />
      </Box>
    </Box>
  )
}
